<template>
<div class="security-settings">
   <div class="setting-top">
<!--     没有地方传图片? -->
     <first-letter class="first-letter-el"></first-letter>
     <span class="username">{{userInfo.firstName}}{{userInfo.middleName}}{{userInfo.lastName}}</span>
     <span class="tag-box tag-el">
       {{role}}:{{userInfo.id}}
     </span>
   </div>
   <el-row class="line-box">
      <el-col class="col-el"
              :span="8"
              :xs="24"
      >
        <span>{{$t('mobile_phone')}}</span>
      </el-col>
      <el-col
        class="col-el"
        :span="8"
        :xs="12"
      >
        <div class="middle-inner">
          <span>{{allData.phone}}</span>
<!--          <div
            class="status-tag tag-el"
            :style="phoneStatusStyle"
          >{{phoneIsAuth}}</div>-->
        </div>
      </el-col>
     <el-col class="col-el"
             :span="8"
             :xs="12"
     >
       <div class="right-box">
         <el-button
           class="btn-el"
           @click="editPhoneHandle"
         >{{$t('modify')}}</el-button>
     </div>
     </el-col>
   </el-row>
  <el-row class="line-box">
    <el-col class="col-el"
            :span="8"
            :xs="24"
    >
      <span>{{$t('email')}}</span>
    </el-col>
    <el-col
      class="col-el"
      :md="8"
      :xs="24"
    >
      <div class="middle-inner">
        <span class="email-p">{{allData.email}}</span>
<!--        <div
          :style="emailStatusStyle"
          class="status-tag tag-el email-p"
        >{{emailIsAuth}}</div>-->
      </div>
    </el-col>
<!--    <el-col class="col-el" :span="8">
      <div class="right-box">
       <el-button
         @click="editEmailHandle"
       >修改</el-button>
      </div>
    </el-col>-->
  </el-row>
  <div class="password-line-box">
    <span>{{$t('password')}}</span>
    <div class="middle-box">
      <span></span>
    </div>
    <span class="right-box">
       <el-button
         class="btn-el"
         @click="editPasswordHandle"
       >{{$t('modify')}}</el-button>
     </span>
  </div>
<!--  <el-row class="line-box">
    <el-col :span="8">
      <span>两步验证</span>
    </el-col>
    <el-col :span="8">
      <div class="middle-inner">
        <span>{{authText}}</span>
        <div
          :style="authStatusStyle"
          class="status-tag tag-el"
        >{{authStatusText}}</div>
      </div>
    </el-col>
    <el-col :span="8">
      <div class="right-box">
       <el-button
         @click="editTwoStepAuthHandle"
       >修改</el-button>
     </div>
    </el-col>
  </el-row>-->
  <old-phone-dialog
    :dialog-show="oldPhoneDialogShow"
    :all-data="allData"
    @ajax-success="oldPhoneValidSuccess"
    @close="oldPhoneDialogShow = false"
  ></old-phone-dialog>
  <phone-edit-dialog
    :dialog-show="newPhoneDialogShow"
    @ajax-success="phoneEditSuccess"
    @close="closePhoneDialog"
  ></phone-edit-dialog>

  <password-edit-dialog
    :dialog-show="passwordDialogShow"
    @ajax-success="passwordEditSuccess"
    @close="closePasswordDialog"
  ></password-edit-dialog>
</div>
</template>

<script>
import oldPhoneDialog from "@/components/myFiles/securitySettings/oldPhoneDialog";
import {GetCustInFo} from '@/api/userCenter.js';
import firstLetter from "@/components/public/firstLetter";
import passwordEditDialog from "@/components/myFiles/securitySettings/passwordEditDialog";
import emailEditDialog from "@/components/myFiles/securitySettings/emailEditDialog";
import phoneEditDialog from "@/components/myFiles/securitySettings/phoneEditDialog";
import {colorRgba} from "@/utils";
import { mapGetters } from 'vuex'
export default {
  name: "index",
  components:{
    oldPhoneDialog,
    phoneEditDialog,
    emailEditDialog,
    passwordEditDialog,
    // twoStepAuthEditDialog,
    firstLetter,
  },
  data() {
    return {
      allData: {},
      phoneStatus: 1,
      emailStatus: 1,
      greenColor: '#41B883',
      redColor: '',
      oldPhoneDialogShow: false,
      preOperationId: null,

      newPhoneDialogShow: false,
      emailDialogShow: false,
      passwordDialogShow: false,
      authDialogShow: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    role() {
      if(this.userInfo.custType == 3){
        return '客户';
      }else {
        return '代理';
      }
    },
    phoneStatusStyle(){
      if(this.phoneStatus){
        return {
          backgroundColor: colorRgba(this.greenColor,0.1),
          color: this.greenColor
        }
      }else {
        return {
          backgroundColor: 'rgba(186, 191, 199, 0.12)',

        }
      }
    },
    emailStatusStyle(){
      if(this.emailStatus){
        return {
          backgroundColor: colorRgba(this.greenColor,0.1),
          color: this.greenColor
        }
      }else {
        return {
          backgroundColor: 'rgba(186, 191, 199, 0.12)',

        }
      }
    },
    authStatusStyle (){
      if(this.emailStatus){
        return {
          backgroundColor: colorRgba(this.greenColor,0.1),
          color: this.greenColor
        }
      }else {
        return {
          backgroundColor: 'rgba(186, 191, 199, 0.12)',

        }
      }
    },
    phoneIsAuth(){
      return '已验证'
    },
    emailIsAuth(){
      return '未验证'
    },
    authStatusText(){
      return '未开启'
    },
    authText(){
      if(!this.userInfo.twoStepAuth){
        return '登录需要额外使用手机、邮箱或身份验证器验证'
      }else {
        if(this.userInfo.twoStepAuthType == 1){
          return '手机或邮箱'
        }else {
          return '身份验证器'
        }
      }
    }
  },
  created(){
    this.getCustomerInfo();
  },
  methods: {
    getCustomerInfo(){
      let parmas = {
        custId: this.userInfo.id,
      }
      GetCustInFo(parmas).then((res) => {
        this.allData = res.data;
      })
    },
    // 修改手机号
    editPhoneHandle() {
      this.oldPhoneDialogShow = true;
   },
    phoneEditSuccess(){
      this.closePhoneDialog();
      //是否考虑跳去login页,重新登录
      localStorage.clear();
      this.$router.push({name: 'login'}).catch(() => {})
    },
    closePhoneDialog(){
      this.newPhoneDialogShow = false;
    },
    oldPhoneValidSuccess(preOperationId){
      this.preOperationId = preOperationId;
      this.oldPhoneDialogShow = false;

      this.newPhoneDialogShow = true;
    },

    // 修改邮箱
    editEmailHandle(){
      this.emailDialogShow = true;
      this.getCustomerInfo();
    },
    emailEditSuccess(){
      this.emailDialogShow = true;
    },
    closeEmailDialog(){
      this.emailDialogShow = false;
    },

    // 编辑密码
    editPasswordHandle(){
      this.passwordDialogShow = true;
    },
    passwordEditSuccess(){
      this.closePasswordDialog();
    },
    closePasswordDialog(){
      this.passwordDialogShow = false;
    },

    // 修改两步验证
    editTwoStepAuthHandle(){
      this.authDialogShow = true;
    },
    authEditSuccess(){
      this.closeAuthDialog();
    },
    closeAuthDialog(){
      this.authDialogShow = false;
    }
  },
}
</script>

<style lang="scss" scoped>
.security-settings {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px;
  .first-letter-el {
    text-align: center;
  }
  .setting-top {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
    .avatar-el {
      width: 36px;
      height: 36px;
    }
    .username {
      font-size: 18px;
      color: #5E5873;
      font-weight: 600;
      padding: 0 10px;
    }
    .tag-box {
      background-color: rgba(186, 191, 199, 0.12);
      font-size: 12px;
    }
  }
  // 公告样式
  .tag-el {
    display: inline-block;
    padding: 3px 6px;
    border-radius: 15px;
  }
  .tag-box,
  .line-box,
  .password-line-box {
    color: #6E6B7B;
  }
  .btn-el {
    font-weight: 400;
  }

  .password-line-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  .right-box {
    text-align: right;
  }
  .line-box {
    margin-bottom: 20px;
  }
  .line-box {
    border-bottom: 1px solid #EBE9F1;
    padding-bottom: 12px;
  }
  .col-el {
    height: 33px;
    line-height: 33px;
  }
  .status-tag {
    display: inline-block;
    margin-left: 10px;
    background-color: rgba(186, 191, 199, 0.12);
    color: #6E6B7B;

  }

  .email-p {
    word-break: break-all;
  }
}
</style>
